import { PayloadAction, createSlice } from "@reduxjs/toolkit";


export type ModalStateType = {
    type: number,
    status: boolean,
    data: any 
} 

export enum MODAL_TYPE {
    all = 1,
    google = 2,
    facebook = 3,
    bing = 4,
    snap = 5
}

const initialState : ModalStateType = {
    type: 0,
    status: false,
    data: {}
};

export const modalSlice = createSlice({
    name: 'modal',
    initialState: initialState,
    reducers: {
        showModal: (state, action: PayloadAction<ModalStateType>) => {
            const { type, status, data } = action.payload;
            state.data = data;
            state.type = type;
            state.status = status;
        },
        hideModal: (state) => {
            state.type = 0;
            state.status = false;
            state.data = {};
        }
    }
})

export const { showModal, hideModal } = modalSlice.actions;

export default modalSlice.reducer;